'use strict';

module.exports = function DraggedImageController({domMapController, mapModel, navigatorShim, dimensionCalculator, pageState, resourceManager, allowedImageTypes, urlDownloader} = {}) {
	if (!domMapController || !mapModel || !navigatorShim || !dimensionCalculator ||!allowedImageTypes || !urlDownloader) {
		console.error({domMapController, mapModel, navigatorShim, dimensionCalculator, pageState, resourceManager, allowedImageTypes, urlDownloader});
		throw new Error('invalid-args');
	}
	const isImageEvent = (evt) => {
			const firstFile = evt?.dataTransfer?.files && evt?.dataTransfer?.files[0],
				fileType = firstFile?.type || '';
			return allowedImageTypes.includes(fileType.toLowerCase());
		},
		hasNoText = (evt) => {
			const eventTypes = evt?.clipboardData?.types || [];
			return !eventTypes.includes('text/plain');
		},
		isUrlEvent = (evt) => {
			return !!(evt?.dataTransfer && evt.dataTransfer.getData('URL'));
		},
		toDataUri = async (uri) => {
			if (uri.startsWith('data:')) {
				return uri;
			}
			if (uri.startsWith('https:')) {
				return urlDownloader.convertToPng(uri);
			}
		},
		getDataUri = (evt) => {
			if (isImageEvent(evt)) {
				const file = evt.dataTransfer.files && evt.dataTransfer.files[0];
				return navigatorShim.readFileAsDataURL(file);
			}
			if (isUrlEvent(evt)) {
				return toDataUri(evt.dataTransfer.getData('URL'));
			}
		},
		isSupportedImage = (dataUri) => {
			return allowedImageTypes.find(t => dataUri.startsWith(`data:${t}`));
		},
		getDraggedImageData = async (evt) => {
			// console.log('DraggedImageController drop', evt);
			// console.log(JSON.stringify(evt.dataTransfer.files));

			const shouldUploadAssets = resourceManager && pageState && pageState.getAllowedActions().uploadChanges,
				dataURI = await getDataUri(evt),
				dimensions = dataURI && isSupportedImage(dataURI) && await dimensionCalculator(dataURI);

			if (!dataURI || !isSupportedImage(dataURI)) {
				return {};
			}
			if (!shouldUploadAssets) {
				return {url: dataURI, dimensions};
			} else {
				const resourceId = await resourceManager.addGoldAsset(dataURI);
				return {url: resourceId, dimensions};
			}
		},
		stageDOM = domMapController.stage.getDOMElement();
	stageDOM.addEventListener('dragover', (evt) => {
		evt.preventDefault();
		evt.dataTransfer.dropEffect = 'move';
	});
	stageDOM.addEventListener('drop', (evt) => {
		if (!isImageEvent(evt) && !isUrlEvent(evt)) {
			return;
		}
		evt.preventDefault();
	});
	stageDOM.addEventListener('drop', async (evt) => {
		if (!isImageEvent(evt) && !isUrlEvent(evt)) {
			return;
		}
		const {url, dimensions} = await getDraggedImageData(evt),
			stageDropCoordinates = domMapController.stage.stagePositionForPointEvent(evt);
		if (url) {
			mapModel.dropImage(url, dimensions.width, dimensions.height, stageDropCoordinates.x, stageDropCoordinates.y, {});
		}
	});
	stageDOM.ownerDocument.addEventListener('paste', (evt) => {
		if (evt.clipboardData?.files?.length && hasNoText(evt) && isImageEvent({dataTransfer: evt.clipboardData})) {
			evt.preventDefault();
		}
	});
	stageDOM.ownerDocument.addEventListener('paste', async (evt) => {
		if (evt.clipboardData?.files?.length && hasNoText(evt) && isImageEvent({dataTransfer: evt.clipboardData})) {
			const {url, dimensions} = await getDraggedImageData({dataTransfer: evt.clipboardData}),
				selectedId = mapModel.getSelectedNodeId(),
				node = mapModel.getCurrentLayout().nodes[selectedId],
				nodeCenterX = Math.round(node.x + node.width / 2),
				nodeCenterY = Math.round(node.y + node.height / 2);
			mapModel.dropImage(url, dimensions.width, dimensions.height, nodeCenterX, nodeCenterY, {});
		}
	});
};
